const PAGE = {
  AGREEMENT_LISTING: 0,
  ASSOCIATION_INSTANCES_DATA: 1,
};
const PAGE_SIZE = {
  AGREEMENT_LISTING: 40,
  ASSOCIATION_INSTANCES_DATA_DND: 999,
  ASSOCIATION_INSTANCES_DATA: 40,
  ASSOCIATION_INSTANCES_DATA_SINGLE_EMAIL_UPLOAD: 11,
  FOLDER_INSTANCES_DATA_SINGLE_EMAIL_UPLOAD: 11,
  INSTANCES_SHOW_MORE_POPUP: 999,
};

export { PAGE, PAGE_SIZE };
